<dw-grid-list-page
  [title]="'Doc::Menu:StockDocTransfers' | abpLocalization"
  [activeView]="agGrid.activeView"
  (createAction)="createEntity()"
  [createActionLabel]="'::Add'"
  (deleteAction)="deleteEntities()"
  [enableExportBtn]="enableExport"
  [enableDeleteBtn]="enableDelete"
  (exportAction)="agGrid.export()"
  [enableDuplicateBtn]="selectedEntities().length == 1"
  [showDuplicateBtn]="true"
  (duplicateAction)="duplicateStockDoc()"
  [hasQuickSearch]="true"
>
  <dw-grid-ag-grid
    [columnDefs]="colDefs"
    [datasource]="datasource"
    (rowClicked)="rowClicked($event)"
    [(selectedRows)]="selectedEntities"
    (selectedRowsClicked)="selectedRowsClicked($event)"
    #agGrid
    [context]="GoliathDocumentEntityNames.StockDocTransfer.shortName"
  >
  </dw-grid-ag-grid>
</dw-grid-list-page>
